import { Skeleton, Typography } from 'antd';
import { useParams } from 'react-router';
import { useGetCaseStatusQuery } from '@ui/features/PatientRegistry/services/api';

export default function CaseCrumb() {
    const { projectId, caseId } = useParams();

    const { data, isLoading, isFetching } = useGetCaseStatusQuery(
        { projectId: projectId!, caseId: caseId! },
        { skip: !projectId || !caseId }
    );

    const patientName = String(data?.patientName ?? '').trim();
    const showSkeleton = (isLoading || isFetching) && !patientName;

    if (showSkeleton) {
        return (
            <Skeleton.Input
                active
                size="small"
                style={{ width: 120 }}
            />
        );
    }

    const label = (patientName || caseId || 'Case').toString().trim();

    return <Typography.Text ellipsis>{label}</Typography.Text>;
}
